/** Pickable Overview tab widgets (all-time ESG + optional charts). */
export type EsgOverviewWidgetId =
  | 'summary_waste_diverted'
  | 'summary_diversion_rate'
  | 'summary_total_co2'
  | 'summary_fill_reports'
  | 'summary_training_hours'
  | 'scope_1'
  | 'scope_2'
  | 'utility_water'
  | 'utility_electricity'
  | 'utility_oil'
  | 'utility_gas'
  | 'chart_recycled'
  | 'chart_incoming'
  | 'chart_carbon_stream'
  | 'chart_carbon_material';

export const ESG_OVERVIEW_WIDGET_LABELS: Record<EsgOverviewWidgetId, string> = {
  summary_waste_diverted: 'Total waste diverted',
  summary_diversion_rate: 'Waste diversion rate',
  summary_total_co2: 'Carbon Offset',
  summary_fill_reports: 'Fill-level reports',
  summary_training_hours: 'Training hours',
  scope_1: 'Scope 1 emissions',
  scope_2: 'Scope 2 emissions',
  utility_water: 'Water',
  utility_electricity: 'Electricity',
  utility_oil: 'Oil',
  utility_gas: 'Gas',
  chart_recycled: 'Waste type & material breakdown (chart)',
  chart_incoming: 'Incoming waste breakdown (chart)',
  chart_carbon_stream: 'Carbon avoidance by stream (chart)',
  chart_carbon_material: 'Carbon avoidance by material (table)',
};

/** Display / dialog order: summaries (diverted first), then utilities, then charts. */
export const PICKABLE_ESG_OVERVIEW_WIDGETS: EsgOverviewWidgetId[] = [
  'summary_waste_diverted',
  'summary_fill_reports',
  'summary_diversion_rate',
  'summary_total_co2',
  'summary_training_hours',
  'scope_1',
  'scope_2',
  'utility_water',
  'utility_electricity',
  'utility_oil',
  'utility_gas',
  'chart_recycled',
  'chart_incoming',
  'chart_carbon_stream',
  'chart_carbon_material',
];

export const DEFAULT_ESG_OVERVIEW_WIDGETS: EsgOverviewWidgetId[] = [
  ...PICKABLE_ESG_OVERVIEW_WIDGETS,
];
